<template>
  <examples-block
    gitUrl="src/components/examples/Table/TableSetWidthColumn.vue"
    title="Таблица с фиксированной шириной колонок">
    <r-table
      :headers="headers"
      :items="items"
    />
  </examples-block>
</template>

<script>
import ExamplesBlock from '@/layouts/ExamplesBlock.vue';

export default {
  name: 'TableSetWidthColumn',
  components: { ExamplesBlock },
  data: () => ({
    headers: [
      {
        field: 'name',
        name: 'Имя',
        style: {
          width: '200px',
        },
      },
      {
        field: 'middleName',
        name: 'Отчество',
        style: {
          width: '250px',
        },
      },
      {
        field: 'firstName',
        name: 'Фамилия',
      },
    ],
    items: [
      {
        name: 'Иванов',
        middleName: 'Иван',
        firstName: 'Иванович',
      },
      {
        name: 'Иванов',
        middleName: 'Иван',
        firstName: 'Иванович',
      },
      {
        name: 'Иванов',
        middleName: 'Иван',
        firstName: 'Иванович',
      },
      {
        name: 'Иванов',
        middleName: 'Иван',
        firstName: 'Иванович',
      },
      {
        name: 'Иванов',
        middleName: 'Иван',
        firstName: 'Иванович',
      },
    ],
  }),
};
</script>
